/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Status from "@/src/components/Status/Status";
import { getStatusBoxConfig } from "@/src/services/serviceWorldService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Stack, SxProps, Theme, Typography } from "@mui/material";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";

type ProductStatusProgressProps = {
  product: AbstractCase;
  sx?: SxProps<Theme>;
};

const ProductStatusProgress = ({ product, sx }: ProductStatusProgressProps) => {
  if (!product) {
    return null;
  }

  const { extraContent, ...statusConfig } = getStatusBoxConfig(product);

  return (
    <Stack spacing={2} sx={sx}>
      <Typography color={"primary"}>
        <strong>{statusConfig.header}</strong>
      </Typography>
      <Status maxPercentage={statusConfig.percentage} />
      <ProductBoxGrid
        key={statusConfig.text}
        items={[
          statusConfig.text && <Typography>{statusConfig.text}</Typography>,
          statusConfig.ctaButton && <Stack sx={{ height: "100%", justifyContent: "center" }}>{statusConfig.ctaButton}</Stack>,
        ]}
      />
      {extraContent}
    </Stack>
  );
};

export default ProductStatusProgress;
